import { UserAgents, UserAgentsHeader } from '../Constants/UserAgents'
import { AkixiWindow } from '../../../NonReact/common/Types/Types'

export const isNativeTeamsApp = (): boolean => {
    const isTeamsAgentEnabled: boolean =
        typeof window !== 'undefined' && (window as AkixiWindow)?.AkixiUserAgentID === UserAgents.TEAMS

    const isTeamsHeaderUA: boolean =
        typeof navigator !== 'undefined' && navigator.userAgent.includes(UserAgentsHeader.TEAMS_HEADER)

    return isTeamsAgentEnabled || isTeamsHeaderUA
}
